import { useAuthContext } from 'contexts';
import { fhirGet } from 'services';
import useSWR from 'swr';
import type { SWRConfiguration } from 'swr';
import type { CommunicationData, Fetched } from 'types';
import { defaultSWROptions } from 'utils';

export const useGetZendeskUnassignedCommunications = () => {
  const { token } = useAuthContext();

  const query = [
    'identifier:not=https://projectwell.io/fhir/identifiers/communication/contact-state|deleted',
    'medium=zendesk', //use medium codes
    'subject:missing=true', // filter out comms assigned to a member
  ].join('&');

  const url = `/Communication/?${query}`;

  const swrOptions: SWRConfiguration = {
    //refreshInterval: 60000, //turned off per ruth's request 2025
    ...defaultSWROptions,
  };

  const {
    data: communicationsData,
    error: communicationsError,
    isValidating: isLoading,
    mutate: communicationsMutate,
  } = useSWR<Fetched<CommunicationData>, Error>([url, token], fhirGet, {
    ...swrOptions
  });

  return {
    communicationsData,
    communicationsError,
    communicationsMutate,
    isLoading,
  };
};
